import React, { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { IoClose, IoEyeOff, IoEye } from "react-icons/io5";
import { MdFilterList } from "react-icons/md";
import { TiExportOutline } from "react-icons/ti";
import { IoMdAdd } from "react-icons/io";
import UserManagementTab from "../tables/UserManagementTab";
import { useDispatch, useSelector } from "react-redux";
import { getAllUsers, saveNewUser } from "../store/actions/user";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { IoIosAddCircle } from "react-icons/io";

const UserManagement = () => {
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [isModalFilter, setIsModalFilter] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("all");
  const [searchText, setSearchText] = useState("");
  const [showCloseButton, setShowCloseButton] = useState(false);
  const [userList, setUserList] = useState([]);
  const [filterQuery, setFilterQuery] = useState({
    limit: "10",
    page: "1",
  });

  // redux logic
  const users = useSelector((state) => state.users);

  const getUserList = () => {
    dispatch(getAllUsers(filterQuery));
  };

  useEffect(() => {
    getUserList();
  }, [dispatch, filterQuery, setFilterQuery]);

  useEffect(() => {
    setUserList(users.usersList);
  }, [users]);

  const userHeader = [
    { key: "Client Name" },
    { key: "Email" },
    { key: "System Address" },
    { key: "Active Services" },
    { key: "Update KYC" },
    { key: "Status" },
    { key: "Action" },
  ];
  const toggleModalFilter = () => {
    setIsModalFilter(!isModalFilter);
  };
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };
  const handleFilter = (e) => {
    e.preventDefault();
  };
  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  const handleTabClick = (tab) => {
    if (tab === "all") {
      delete filterQuery.status;
      setFilterQuery({ ...filterQuery });
    } else if (tab === "active") {
      setFilterQuery({ ...filterQuery, status: "1" });
    } else if (tab === "inactive") {
      setFilterQuery({ ...filterQuery, status: "0" });
    }
    setActiveTab(tab);
  };
  const handleSearchText = (e) => {
    setSearchText(e.target.value);
  };
  const handleSearch = (e) => {
    e.preventDefault();
    setFilterQuery({
      ...filterQuery,
      keyword: e.target.defaultSearch.value,
      keywordName: ["username", "email"],
    });
    setShowCloseButton(true);
  };
  const handleClearSearch = () => {
    delete filterQuery.keyword;
    delete filterQuery.keywordName;
    setFilterQuery({ ...filterQuery });
    setSearchText("");
    setShowCloseButton(false);
  };

  const handleSaveUser = (e) => {
    e.preventDefault();
    dispatch(
      saveNewUser({
        username: e.target.username.value,
        email: e.target.email.value,
        password: e.target.password.value,
        createdSource: "Admin",
      })
    );
    toast.success("User created successfully!", {
      position: "top-right",
      autoClose: 600,
      onClose: () => {
        getUserList();
      },
    });
  };
  return (
    <div className="relative">
      <div className=" bg-top p-1 fixed  w-full lg:max-w-[calc(100%-16rem)] z-10 h-auto !bg-[#cbd5e0]">
        <div className="flex lg:flex-row flex-col items-center justify-between p-2 gap:4 ">
          <div className="relative ">
            <form className=" flex w-full " onSubmit={handleSearch}>
              <span className="absolute inset-y-0 left-0 flex items-center pl-3  text-gray-500">
                <FaSearch />
              </span>

              <input
                type="text"
                id="default-search"
                value={searchText}
                onChange={handleSearchText}
                name="defaultSearch"
                placeholder="Search..."
                className="w-[275px]  pl-10 pr-4 py-2 text-gray-500 border border-gray-300 rounded-lg focus:outline-none focus:ring-0 focus:ring-blue-500"
              />
              <button
                type="submit"
                className="text-white  absolute right-0 bottom-1 top-1 bg-[#02256d] hover:bg-blue-800  focus:outline-none focus:ring-0 font-medium rounded-lg text-sm px-4 py-0 mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                Search
              </button>
              {showCloseButton && (
                <button
                  type="submit"
                  className="text-red-600 text-bold absolute right-20 bottom-1 top-1  focus:outline-none focus:ring-0 font-medium rounded-lg text-sm px-2 py-0 mr-2  "
                  onClick={handleClearSearch}
                >
                  X
                </button>
              )}
            </form>
          </div>
          <div className="w-full sm:w-auto flex flex-col lg:flex-row justify-around gap-2 lg:gap-4 mt-2">
            <div className="w-full flex items-center flex-row ">
              <Link
              to="/admin/user-management/userAdd"
                // onClick={toggleModal}
                className="w-full sm:w-auto action-btn flex items-center justify-center gap-2 px-4 py-1 text-sm font-medium text-text  bg-[#fdbc12] p-2 h-[45px] rounded-lg"
                // type="button"
              >
                <IoIosAddCircle /> Add New
              </Link>
              {/* Modal */}
              {/* {isModalOpen && (
               
              )} */}
            </div>
          </div>
        </div>
      </div>
      {/* max-w-[calc(100%-17rem)] */}
      <div className="lg:pt-32 pt-24 ">
        <div className="flex flex-col sm:flex-row justify-between items-center w-full gap-2 bg-card p-2">
          {/* Title Section */}
          <div>
            <h2 className="text-lg font-medium text-text">Client Management</h2>
          </div>
          <div className="flex flex-row gap-2">
            <div className="w-full flex items-center flex-row ">
              <button
                onClick={toggleModalFilter}
                className="w-full sm:w-auto action-btn flex items-center justify-center gap-2 px-4 py-1 text-sm font-medium text-text  hover:bg-blue-500 hover:text-white border-2 border-blue-500  rounded-lg"
                type="button"
              >
                <MdFilterList className="w-5 h-5" /> Filter
              </button>

              {/* Filter Modal */}
              {isModalFilter && (
                <div
                  id="crud-modal"
                  className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden bg-gray-900 bg-opacity-50"
                >
                  <div className="relative p-4 w-full max-w-md h-auto">
                    {/* Modal Content */}
                    <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                      {/* Modal Header */}
                      <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                          Filter User
                        </h3>
                        <button
                          type="button"
                          className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                          onClick={toggleModalFilter}
                        >
                          <IoClose className="w-5 h-5" />
                        </button>
                      </div>

                      {/* Modal Body */}
                      <form onClick={handleFilter} className="p-4 md:p-5">
                        <div className="grid gap-4 mb-4 grid-cols-1 sm:grid-cols-2">
                          <div>
                            <label
                              htmlFor="dateTo"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                              Date to
                            </label>
                            <input
                              type="date"
                              id="dateTo"
                              onClick={(e) => e.target.showPicker()} // Opens the calendar picker
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                              required
                            />
                          </div>
                          <div>
                            <label
                              htmlFor="dateFrom"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                              Date From
                            </label>
                            <input
                              type="date"
                              id="dateTo"
                              onClick={(e) => e.target.showPicker()} // Opens the calendar picker
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                              required
                            />
                          </div>
                        </div>
                        <button
                          type="submit"
                          className="w-full mt-2 justify-center	 text-white inline-flex items-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                        >
                          Submit
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="w-full flex items-center flex-row ">
              <button className="w-full sm:w-auto action-btn flex items-center justify-center gap-2 px-4 py-1 text-sm font-medium text-text  hover:bg-blue-500 hover:text-white border-2 border-blue-500  rounded-lg">
                <TiExportOutline /> Export
              </button>
            </div>
          </div>
          {/* Tabs Section */}
          <div>
            <ul
              className="flex flex-wrap -mb-px text-sm font-medium text-center"
              role="tablist"
            >
              {/* All Tab */}
              <li className="mr-4" role="presentation">
                <button
                  className={`px-4 py-1 rounded-lg transition-all duration-200 ${
                    activeTab === "all"
                      ? "bg-blue-600 text-white shadow-md"
                      : "bg-gray-100 text-gray-500 hover:bg-gray-200"
                  }`}
                  id="all"
                  type="button"
                  role="tab"
                  aria-selected={activeTab === "all"}
                  onClick={() => handleTabClick("all")}
                >
                  All
                </button>
              </li>

              {/* Active Tab */}
              <li className="mr-4" role="presentation">
                <button
                  className={`px-4 py-1 rounded-lg transition-all duration-200 ${
                    activeTab === "active"
                      ? "bg-blue-600 text-white shadow-md"
                      : "bg-gray-100 text-gray-500 hover:bg-gray-200"
                  }`}
                  id="active"
                  type="button"
                  role="tab"
                  aria-selected={activeTab === "active"}
                  onClick={() => handleTabClick("active")}
                >
                  Active
                </button>
              </li>

              {/* Inactive Tab */}
              <li className="mr-4" role="presentation">
                <button
                  className={`px-4 py-1 rounded-lg transition-all duration-200 ${
                    activeTab === "inactive"
                      ? "bg-blue-600 text-white shadow-md"
                      : "bg-gray-100 text-gray-500 hover:bg-gray-200"
                  }`}
                  id="inactive"
                  type="button"
                  role="tab"
                  aria-selected={activeTab === "inactive"}
                  onClick={() => handleTabClick("inactive")}
                >
                  Inactive
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="">
        <UserManagementTab
          userHeader={userHeader}
          userProducts={userList}
          loading={users.loading}
          totalUsers={users.totalCount}
          filterQuery={filterQuery}
          filterQueryChange={setFilterQuery}
        />
      </div>
    </div>
  );
};

export default UserManagement;
